exports.onRouteUpdate = () => {
  const manifestEl = document.head.querySelector(`link[rel="manifest"]`)

  if (manifestEl && process.env.GATSBY_CDN_HASH !== 'undefined') {
    manifestEl.setAttribute(`href`, `/assetscdn/${process.env.GATSBY_CDN_HASH}/manifest.webmanifest`);
  }
}
